module.exports = __webpack_public_path__ + "img/rolling10ex_bg.f503314c.png";